  $(function(){
    $('.card-wrapper').each(function(e){
      $(this).children('.card-information').children('.jdgm-prev-badge').attr('style','display:none !important');
      var zz = $(this).children().find('.card-information .jdgm-widget').children().data('averageRating');
      zz = parseFloat(zz).toFixed(2);
      if(zz != 0.00){
        $(this).children().find('.CustomratingDiv .rating').html(zz);
 } else {
          $(this).children().find('.CustomratingDiv .jdgm-star').removeClass('jdgm-star');
        }
    });
  });
